<i *ngIf="searchGeneralLook" class="fa fa-search"></i>
<input type="text" [(ngModel)]="searchTerm" [placeholder]=" 'COMP-TITLE' | translate " class="project-search"
    (focus)="showResoultBlock()">
<div class="clickable-title-holder" (focus)="showResoultBlock()" *ngIf="!this.showProperties">
    <ul class="row search-project" (focus)="showResoultBlock()">
        <li class="proj-category-holder" *ngFor="let category of categories" (focus)="showResoultBlock()">
            <h5 *ngIf="category.title !== 'undefined'">{{ category.title }}</h5>
            <ul class="list-proj clickable-title">
                <li *ngFor="let item of category.list | projFilter:searchTerm" (click)='viewItemDetails($event, item)'
                    (focus)="showResoultBlock()">{{ item.title }}</li>
            </ul>
        </li>
    </ul>
</div> 
<div appNgInitDirective class="proj-list-propetties" *ngIf="this.showProperties">
    <ul class="row search-project" (focus)="showResoultBlock()">
        <li class="proj-category-holder" *ngFor="let category of categories" (focus)="showResoultBlock()">
            <h5 *ngIf="category.title !== 'undefined'">{{ category.title }}</h5>
            <ul class="list-proj clickable-title">
                <li *ngFor="let item of category.list | projFilter:searchTerm" (focus)="showResoultBlock()" [class.hide-projList-in-menu]="!item.toggleProjListMenu">
                    <!-- {{ item.title }} -->
                    <!-- <div *ngIf="item.buildings"><span  *ngFor="let building of item.buildings">{{ building.name }}</span>
                        <div *ngIf="item.statusCounter" class="statistics"><span class="freeStatistics">פנוי: {{ item.statusCounter.free }}</span> <span class="waitingStatistics">בהמתנה: {{ item.statusCounter.waiting }}</span><span class="soldStatisctics">נמכר: {{ item.statusCounter.sold }}</span></div>
                    </div> -->
                    <!-- <div *ngIf="itemToEdit = item.id" class="col m12 iframe da-iframe" [innerHtml]="item.spirical | safe: 'html'"></div> -->
                    <!-- <div class="col m12 iframe da-iframe" [innerHtml]="item.spirical | safe: 'html'"></div> -->
                    <mat-card class="example-card" (click)='viewItemDetails($event, item)'>
                        <mat-card-title-group class="search-proj-card-title">
                            <mat-card-title>{{ item.title }}</mat-card-title>
                            <!-- <mat-card-subtitle>Small</mat-card-subtitle> -->
                            <!-- <img mat-card-sm-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" > -->
                        </mat-card-title-group>
                        <mat-card-content>
                            <!-- <div *ngIf="item.buildings" class="building-card-title">
                                <a *ngFor="let building of item.buildings" (click)="goToBuilding(building.uid, item)">{{ building.name }}</a>
                            </div> -->
                            <div *ngIf="item.buildings" class="statistic-holder">
                                <div *ngIf="item.statusCounter" class="statistics">
                                    <span matTooltip="פנוי" class="free" matBadgeOverlap="true"> {{ 'FREE' | translate }} {{
                                        item.statusCounter.free }}</span>
                                    <span matTooltip="בהמתנה" class="waiting waitingStatistics" matBadgeOverlap="true"  
                                        matBadgeColor="yellow"> {{ 'IN-REGISTRATION' | translate }} {{ item.statusCounter.waiting }}</span>
                                    <span matTooltip="נמכר" class="sold soldStatisctics" matBadgeOverlap="true"> {{ 'SOLD' | translate }} {{ item.statusCounter.sold }}</span>
                                </div>
                            </div>
                        </mat-card-content>
                        <!-- <mat-card-actions>
                            <button (click)='viewItemDetails($event, item)' mat-button class="btn btn-small">לעבור
                                לפרויקט</button>
                        </mat-card-actions> -->
                    </mat-card>
                </li>
            </ul>
        </li>
    </ul>
</div>